import { ReactElement } from "react";
import { className } from "../../../../shared/helpers";
import { IComponent } from "../../../../services/http/component/models/IComponent";
import { TableColumn } from "../TableWrapper";
import tableStyles from "../ResultsTable.module.scss";
import styles from "./MainContent.module.scss";
import { ComponentRowViewModel } from "../../ComponentTableViewModel";

interface MainContentProps
{
    tableColumns: TableColumn[];
    components: ComponentRowViewModel[];
    selectedComponent: IComponent;
    selectComponent: (x: IComponent) => void
}

const MainContent = (props: MainContentProps): ReactElement =>
{
    const lastValue: TableColumn = props.tableColumns.find(x => x.label === "Last Value")!;
    const last30Days: TableColumn = props.tableColumns.find(x => x.label === "Last 30 days")!;
    const last24Hours: TableColumn = props.tableColumns.find(x => x.label === "Last 24 hours")!;
    const aggregationHasValue = (x?: number): boolean => x !== undefined && x !== null;

    return (
        <>
            {props.components.map((x, i) =>
            {
                const aggregation = x.measures;
                const noMeasures = !x.dataSourceId;
                const uomCode = aggregation?.dataSourceUomCode;

                return (
                    <tr
                        key={`main_row_${i}`}
                        data-row={i}
                        onClick={() => props.selectComponent(x.component)}
                        {...className(
                            tableStyles.tableRow, styles.row,
                            { "active": props.selectedComponent === x.component })
                        }
                    >
                        {lastValue.visible && (
                            <td data-column="Last Value">
                                {noMeasures
                                    ? ""
                                    : aggregation
                                        ? aggregationHasValue(aggregation.lastValue) && `${aggregation.lastValue.toFixed(2)} ${uomCode}`
                                        : <span className={tableStyles.skeleton} />
                                }
                            </td>
                        )}

                        {last24Hours.visible && (
                            noMeasures
                                ? <>
                                    <td data-column="Day Average"></td>
                                    <td data-column="Day Min"></td>
                                    <td data-column="Day Max"></td>
                                </>
                                : aggregation
                                    ? (
                                        <>
                                            <td data-column="Day Average">{aggregationHasValue(aggregation.last24HoursAverage) && `${aggregation.last24HoursAverage.toFixed(2)} ${uomCode}`}</td>
                                            <td data-column="Day Min">{aggregationHasValue(aggregation.last24HoursMin) && `${aggregation.last24HoursMin.toFixed(2)} ${uomCode}`}</td>
                                            <td data-column="Day Max">{aggregationHasValue(aggregation.last24HoursMax) && `${aggregation.last24HoursMax.toFixed(2)} ${uomCode}`}</td>
                                        </>
                                    ) : <td colSpan={3}><span className={tableStyles.skeleton} /></td>
                        )}

                        {last30Days.visible && (
                            noMeasures
                                ? <>
                                    <td data-column="Day Average"></td>
                                    <td data-column="Day Min"></td>
                                    <td data-column="Day Max"></td>
                                </>
                                : 
                                aggregation
                                    ? (
                                        <>
                                            <td data-column="Month Average">{aggregationHasValue(aggregation.last30DaysAverage) && `${aggregation.last30DaysAverage.toFixed(2)} ${uomCode}`}</td>
                                            <td data-column="Month Min">{aggregationHasValue(aggregation.last30DaysMin) && `${aggregation.last30DaysMin.toFixed(2)} ${uomCode}`}</td>
                                            <td data-column="Month Max">{aggregationHasValue(aggregation.last30DaysMax) && `${aggregation.last30DaysMax.toFixed(2)} ${uomCode}`}</td>
                                        </>
                                    ) : <td colSpan={3}><span className={tableStyles.skeleton} /></td>
                        )}
                    </tr>
                )
            })}
        </>
    )
}

export default MainContent;